import { Radio, RadioGroupProps } from '@arco-design/web-react';

const RadioGroup = Radio.Group;
export const RadioOptions = ({ options, value, onChange, ...rest }: RadioGroupProps) => {
  return <RadioGroup options={options} value={value} onChange={onChange} {...rest} />;
};
